
document.onload = new function(){
    var myJson = JSON.parse(document.getElementById("language-json").innerHTML);
    var currentLanguage = myJson["language"]
   
    if (!usupportedBrowserAlreadyChecked() || currentLanguage != lastCurrentLanguage()) {
        var result = bowser.getParser(window.navigator.userAgent);
        if(
            /* Desktops Supported */
            (result.parsedResult.browser.name != "Safari" || compareVersions(result.parsedResult.browser.version, "<", "13.1.2" )) &&
            (result.parsedResult.browser.name != "Firefox" || compareVersions(result.parsedResult.browser.version, "<", "79.0" )) &&
            (result.parsedResult.browser.name != "Chrome" || compareVersions(result.parsedResult.browser.version, "<", "61.0.3163.128" )) &&
            (result.parsedResult.browser.name != "Opera" || compareVersions(result.parsedResult.browser.version, "<", "71.0.3770.198" )) &&
            (result.parsedResult.browser.name != "Microsoft Edge" || compareVersions(result.parsedResult.browser.version, "<", "85.0.564.68" ))
        ){
            var alertBody = myJson["body"];
            alert(alertBody);
            var date = new Date();
            date.setTime(date.getTime()+(2 * 60 * 60 * 1000));
            document.cookie = "unsupportedBrowserWarningAlreadyProvided=true; expires=" + date.toGMTString()
            document.cookie = "lastCurrentLanguage=" + currentLanguage;
        }
    }   
}

function compareVersions(v1, comparator, v2) {
    "use strict";
    var comparator = comparator == '=' ? '==' : comparator;
    if(['==','===','<','<=','>','>=','!=','!=='].indexOf(comparator) == -1) {
        throw new Error('Invalid comparator. ' + comparator);
    }
    var v1parts = v1.split('.'), v2parts = v2.split('.');
    var maxLen = Math.max(v1parts.length, v2parts.length);
    var part1, part2;
    var cmp = 0;
    for(var i = 0; i < maxLen && !cmp; i++) {
        part1 = parseInt(v1parts[i], 10) || 0;
        part2 = parseInt(v2parts[i], 10) || 0;
        if(part1 < part2)
            cmp = 1;
        if(part1 > part2)
            cmp = -1; 
    }
    return eval('0' + comparator + cmp);
}

function usupportedBrowserAlreadyChecked(){
    if(typeof document.cookie.split('; ').find(row => row.startsWith('unsupportedBrowserWarningAlreadyProvided')) == "undefined"){
        return false;
    }
    return true;
}

function lastCurrentLanguage(){
    if(typeof document.cookie.split('; ').find(row => row.startsWith('lastCurrentLanguage')) == "undefined"){
        return "";
    }
    return document.cookie.split('; ').find(row => row.startsWith('lastCurrentLanguage')).split('=')[1];
}